{
  "en": {
    "courseBookmark": {
      "title": "Bookmarked courses",
      "emptyState": {
        "title": "You haven't bookmarked any courses yet",
        "body": "Mark courses you are interested in with the <i class='bi bi-heart text-primary'></i> and complete them whenever you're ready."
      },
      "links": {
        "toCourses": "Discover courses"
      }
    }
  }
}
